import { useQuery } from 'react-query';

import { getAllUserGroups as queryFn } from 'api/endPoints/getAllUserGroups';

export interface IAllUserGroups {
    customer_id: number;
    group_id: number;
    group_name: string;
    projects_list: { project_id: number; project_name: string }[];
    roles_list: { role_id: number; role_name: string }[];
    user_id: number | null;
}

export const useQueryGetAllUserGroups = ({ enabled, isProjectCreation = false }) => {
    return useQuery<IAllUserGroups[], QueryError>('getAllUserGroups', () => queryFn({ isProjectCreation }), {
        enabled,
    });
};
